module.exports = __webpack_public_path__ + "static/media/vencimiento_verde.d60008d3.svg";